import { Link } from 'react-router-dom'

const LINKS = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/security', label: 'IT and security' },
  { to: '/dpa', label: 'DPA' },
]

export default function Footer() {
  return (
    <footer className="bg-navy text-stone border-t-2 border-golden py-8">
      <div className="max-w-5xl mx-auto px-6 flex flex-col sm:flex-row sm:items-end gap-6 justify-between">
        <div>
          <p className="hl text-2xl text-stone">Day One</p>
          <p className="text-sm text-stone/70 mt-1">
            An{' '}
            <a
              href="https://mvpclub.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="text-golden underline underline-offset-2 hover:text-amber transition"
            >
              MVP Club Consulting
            </a>{' '}
            product. Denver, Colorado.
          </p>
        </div>

        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
          {LINKS.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className="mono-label text-stone/70 hover:text-stone transition"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  )
}
